import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';

const USER_KEY_Curr = 'curr-user';

const USER_KEY_Kyc = 'Kyc-user';
const UsertBal = 'UsertBal';

@Injectable({
  providedIn: 'root'
})


export class TokenStorageService {
  //public isUserLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  
  public data1 = new BehaviorSubject('');
  currentData1 = this.data1.asObservable();

  updateMessage1(item: any) {
    this.data1.next(item);
  }

  public data2 = new BehaviorSubject('');
  currentData2 = this.data1.asObservable();

  updateMessage2(item: any) {
    this.data2.next(item);
  }

  //public cc: BehaviorSubject<string> = new BehaviorSubject<string>("");
  constructor() {
    this.currentData1.subscribe(() => this.getUser()); //use for call when no. verified}
  }

  signOut(): void {
    
    sessionStorage.clear();
    
  }


  public saveToken(token: string): void {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string | null {
    return sessionStorage.getItem(TOKEN_KEY);
  }
  
  public saveUser(user: any): void {
    
    sessionStorage.removeItem(USER_KEY);
    sessionStorage.setItem(USER_KEY, JSON.stringify(user));

  }

  public getUser(): any {
    
    const user = sessionStorage.getItem(USER_KEY);

    if (user) {
      return JSON.parse(user);
    }
    return {};
  }


  getEmployeeDetail() {
    return this.currentData1;
  }

  getEmployeeDetail2() {
    return this.currentData2;
  }

  public saveUSERCurrCountry(val: string): void {
    sessionStorage.removeItem(USER_KEY_Curr);
    sessionStorage.setItem(USER_KEY_Curr, val);
  }

  public getUSERCurrCountry(): string | null {
    
    return sessionStorage.getItem(USER_KEY_Curr);
  }

  public saveUSERKyc(val: string): void {
    
    sessionStorage.removeItem(USER_KEY_Kyc);
    sessionStorage.setItem(USER_KEY_Kyc, val);
  }

  public getUSERKyc(): string | null {
    return sessionStorage.getItem(USER_KEY_Kyc);
  }

  public isLoggedIn() {
    if (sessionStorage.getItem(USER_KEY)) {
      return true;
    }
    return false;
  }


  public saveUsertBal(val: any): void {
    
    sessionStorage.removeItem(UsertBal);
    sessionStorage.setItem(UsertBal, JSON.stringify(val));
  }

  public getUsertBal(): any {
    
    const userBal = sessionStorage.getItem(UsertBal);

    if (userBal) {
      return JSON.parse(userBal);
    }
    return {};
    
  }

  public randomString(length: number) {
    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }


}

